import { MessageDialog } from './../../dialogs/message/message.dialog';
import { ErrorItemArray } from './../../models/domain/error.item';
import { Component, OnInit } from '@angular/core';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { GetErrorsRequest } from '../../models/ss-api/requests/get.errors.request';
import * as moment from 'moment';
import { DialogService } from '../../services/modal-dialogs';
import { SortBot } from '../../helpers/sort';

@Component({
    selector: 'errors',
    templateUrl: './errors.component.html',
    styleUrls: ['./errors.component.scss']
})
export class ErrorsComponent implements OnInit {

    IsBusy: boolean = false;

    StartDate: Date = moment().subtract(30, 'days').toDate();
    EndDate: Date = new Date();

    resultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 25;

    Errors: ErrorItemArray = new ErrorItemArray();
    ErrorFilter: string;

    constructor(private api: ssApiService, private gb: GlobalService, private dialogService: DialogService) { }

    SortBy(sortVar1, sortVar2?) {
        this.Errors = SortBot.SortAuto(this.Errors, sortVar1, sortVar2);
    }

    ngOnInit() {
        this.gb.SetPageTitle('Errors');
        this.LoadErrors();
    }

    LoadErrors() {
        this.IsBusy = true;

        let request: GetErrorsRequest = {
            StartDate: this.StartDate,
            EndDate: this.EndDate
        };

        let disposable = this.api.GetErrors(request).subscribe(response => {
            this.Errors = response.Data.sort((left, right) => {
                if (left.DateCreated > right.DateCreated) {
                    return -1;
                } else {
                    return 1;
                }
            });
            this.IsBusy = false;
            disposable.unsubscribe();
        });
    }

    ShowDetails(error) {
        let message = '<strong>JSON Request: </strong>' + error.JSONRequest + '<br><br> <strong>Error Stack: </strong>' + error.ErrorStack;
        let disposable = this.dialogService.addDialog(MessageDialog, {
            Title: 'Error Stack',
            Message: message
        }, {
            height: 800
        }).subscribe(response => {
            disposable.unsubscribe();
        });
    }

    paginateErrors(e) {
        // console.log("paginateSearch :", e);
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }

}
